import showcase from '@app/lang/reverse/it/showcase';
import { COMMON_IT } from '@app/lang/reverse/it/common';
import { INTERVIEWING_IT } from '@app/lang/reverse/it/interviewing';
import { SEARCHING_IT } from '@app/lang/reverse/it/searching';
import { CLOSING_IT } from '@app/lang/reverse/it/closing';
import { SUCCESS_FEE_IT } from '@app/lang/reverse/it/success-fee';
import { HOMEPAGE_IT } from '@app/lang/reverse/it/homepage';
import { CANDIDATE_DETAILS_IT } from '@app/lang/reverse/it/candidate-details';
import { ERRORS_IT } from '@app/lang/reverse/it/errors';
import * as PROFILING_IT from '@app/lang/reverse/it/profiling.json';
import * as LOGIN_IT from '@app/lang/reverse/it/login.json';
import * as GLOBAL_COMPENSATION_IT from '@app/lang/reverse/it/global-compensation.json';

const it = {
  translation: {
    header: {
      welcome: 'Bentornato',
      share: 'Condividi',
      hide_compensation: 'Presenta con retribuzioni oscurate',
      show_compensation: 'Mostra retribuzioni',
    },
    hero: {
      backToHomepage: 'Tutti i tuoi servizi',
      backToHomepage_headHunter: 'Tutti i servizi del cliente',
      prospect: {
        title: 'Prospetto di calcolo success fee',
      },
      steps: {
        profiling: {
          title: 'Profilo',
          title_no_miro: 'Referenti',
          description: 'Inizio',
        },
        searching: {
          title: 'Ricerca',
          description: '1-10°GG',
        },
        showcase: {
          title: 'Showcase',
          description: '11°GG',
        },
        interviewing: {
          title: 'Colloqui',
          title_marketing: 'Talenti',
          description: '11-20°GG',
        },
        closing: {
          title: 'Assunzioni',
          description: 'Fine',
        },
      },
      helper: {
        profiling: {
          'to-do':
            'Ciao. In queste pagine <strong>puoi vedere</strong> ogni step delle attività che svolgiamo per te, aggiornate in tempo reale.',
          'to-do_withName':
            'Ciao {{ name }}. In queste pagine <strong>puoi vedere</strong> ogni step delle attività che svolgiamo per te, aggiornate in tempo reale.',
          doing: '$t(hero.helper.profiling.to-do)',
          doing_withName: '$t(hero.helper.profiling.to-do_withName)',
          done: '$t(hero.helper.profiling.to-do)',
          done_withName: '$t(hero.helper.profiling.to-do_withName)',
        },
        searching: {
          'to-do':
            'Durante la ricerca, fino a che non saranno disponibili i dati, <strong>vedrai le attività che svolgo per te.</strong>',
          doing:
            'Durante la ricerca, fino a che non saranno disponibili i dati, <strong>vedrai le attività che svolgo per te.</strong>',
          done: 'Abbiamo presentato ai candidati la tua azienda e la posizione. Questo è <strong>quello che i numeri ci raccontano</strong>.',
        },
        showcase: {
          'to-do':
            'Durante la ricerca, fino a che non saranno disponibili i dati, <strong>vedrai le attività che svolgo per te.</strong>',
          doing:
            'Durante la ricerca, fino a che non saranno disponibili i dati, <strong>vedrai le attività che svolgo per te.</strong>',
          done: 'Ricerca conclusa! Qui sotto trovi i <strong>numeri</strong> conclusivi e la <strong>JRA</strong>, la nostra analisi finale.',
        },
        interviewing: {
          'to-do':
            'In questa fase ti <strong>mostreremo i candidati</strong> e avremo bisogno di raccogliere <strong>feedback tempestivi</strong>',
          doing:
            'Siamo nel vivo della selezione. Ricorda che <strong>più siamo tempestivi, maggiori sono le probabilità</strong> di assumere.',
          done: 'Siamo nel vivo della selezione. Ricorda che <strong>più siamo tempestivi, maggiori sono le probabilità</strong> di assumere.',
        },
        closing: {
          'to-do':
            'È la fase finale: la più delicata. <strong>Negoziazione, dimissioni e onboarding</strong>.',
          doing:
            'È la fase finale: la più delicata. <strong>Negoziazione, dimissioni e onboarding</strong>.',
          done: 'È la fase finale: la più delicata. <strong>Negoziazione, dimissioni e onboarding</strong>.',
        },
        marketing: {
          profiling: {
            'to-do':
              'Ciao. In queste pagine puoi vedere i <strong>talenti che abbiamo selezionato per te</strong> e, se decidi di incontrarli, <strong>tutto ciò che riguarda il loro stato nel processo di selezione</strong>.',
            'to-do_withName':
              'Ciao {{ name }}. In queste pagine puoi vedere i <strong>talenti che abbiamo selezionato per te</strong> e, se decidi di incontrarli, <strong>tutto ciò che riguarda il loro stato nel processo di selezione</strong>.',
            doing: '$t(hero.helper.marketing.profiling.to-do)',
            doing_withName:
              '$t(hero.helper.marketing.profiling.to-do_withName)',
            done: '$t(hero.helper.marketing.profiling.to-do)',
            done_withName: '$t(hero.helper.marketing.profiling.to-do_withName)',
          },
          interviewing: {
            'to-do':
              'Non appena verranno identificati talenti che potrebbero <strong>fare al caso tuo</strong>, li troverai qui.',
            doing:
              "I candidati interessanti non rimangono disponibili a lungo. <strong>Non perdere l'occasione di incontrarli</strong>.",
            done: '$t(hero.helper.marketing.interviewing.doing)',
          },
        },
      },
    },
    profile: {
      contract: {
        title: 'Qui trovi il contratto di questo mandato',
        title_marketing:
          'Scopri i migliori talenti,<br/>paga solo quando assumi.',
        download: 'Scarica il contratto',
      },
      references: {
        title: 'I tuoi referenti',
        blank: {
          title: 'Stiamo cercando la persona giusta per questo servizio',
          text: 'Vogliamo il miglior head hunter che abbiamo a disposizione...',
        },
      },
      mirror: {
        body: '<strong>Un nuovo modo di fare recruiting</strong><br><br>FLESSIBILE, DIGITALE, SPECIALIZZATO.',
        link: 'Scopri il recruitment collaborativo',
      },
    },
    general: {
      error: {
        title: 'Si è verificato un problema',
        subtitle:
          'Prova ad aggiornare la pagina. Se non si risolve riprova più tardi',
        hash: {
          title: 'Questo link è scaduto.',
          subtitle:
            'Dovresti aver ricevuto il <strong>link corretto</strong> in una delle <strong>nostre ultime email</strong>',
          disclaimer:
            'Non riesci a trovarla? <strong>Contatta i tuoi referenti</strong>',
        },
        unauthorized: {
          title: 'Questo link sembra sbagliato.',
          subtitle:
            'Dovresti aver ricevuto il <strong>link corretto</strong> in una <strong>nostra email</strong>, poco tempo <strong>dopo la firma del contratto.</strong>',
          disclaimer:
            'Non riesci a trovarla? <strong>Contatta i tuoi referenti</strong>',
        },
        unauthorizedHomepage: {
          title: 'Non sei autorizzato a visualizzare questa pagina.',
          subtitle: '',
          disclaimer: '',
        },
      },
      document_title: {
        profiling: 'Profilo',
        searching: 'Ricerca',
        interviewing: 'Colloqui',
        closing: 'Chiusura',
        showcase: 'Showcase',
      },
      document_title_reverse_marketing: {
        profiling: '$t(hero.steps.profiling.title_no_miro)',
        searching: '$t(hero.steps.searching.title)',
        interviewing: '$t(hero.steps.interviewing.title_marketing)',
        closing: '$t(hero.steps.closing.title)',
        showcase: '$t(hero.steps.showcase.title)',
      },
      date_on: 'il',
      date_hour: 'alle',
    },
    candidate: {
      hero: {
        title: 'stai cercando:',
        back_label: 'Indietro',
      },
      infos: {
        age: 'anni',
        benefits: 'Benefit attuali',
        bonuses: 'Bonus attuali',
      },
      sections: {
        horse: {
          title: 'Stato attuale',
        },
        bet: {
          open_chat: 'Scrivi in chat a <strong>{{ name }}</strong>',
        },
        curriculum: {
          title: 'Curriculum Vitae',
          screening: 'Screening ranking',
          button: 'Scarica il curriculum',
        },
        summary: {
          otherSelectionsTitle: 'Altri processi di selezione',
        },
        concerns: {
          intro:
            '{{ name }} è un profilo molto interessante ma non completamente in linea con i requisiti.',
        },
      },
    },
    footer: {
      company: 'Reverse SpA',
      headquarter: 'Sede legale: Piazza Sigmund Freud 1, 20154 Milano',
      informations: [
        'Partita IVA: 09714690964',
        'PEC: reversespa@pec.it',
        'Registro delle Imprese di Milano - 2109818',
        'Capitale sociale interamente versato: 50.000€',
        'Numero REA: MI - 2109818',
      ],
      menu: {
        contact: {
          label: 'Contattaci',
          slug: 'contattaci',
        },
        legal: {
          label: 'Legal',
          slug: 'legal',
        },
        cookies: {
          label: 'Cookies',
          url: 'https://www.iubenda.com/privacy-policy/60130224/cookie-policy',
        },
      },
    },
    modal: {
      share: {
        title: 'Condividi l’avanzamento della selezione con altre persone',
        imageAlt: 'Share link modal content',
        inputs: {
          first_name: {
            label: 'Nome',
            placeholder: 'Nome',
          },
          last_name: {
            label: 'Cognome',
            placeholder: 'Cognome',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
            hint: "L'email non corisponde al dominio con sui sei registrato sei sicuro di voler continuare?",
          },
          lang: {
            label: 'Lingua',
            placeholder: 'Seleziona lingua',
          },
        },
        isCompensationPackageVisible: {
          label:
            'Consenti alla persona invitata di <strong>vedere i pacchetti retributivi</strong> dei candidati.',
        },
        lang_options: {
          it: 'Italiano',
          en: 'Inglese',
          de: 'Tedesco',
          fr: 'Francese',
          es: 'Spagnolo',
        },
        button: 'Invita',
        shared_with: 'Condiviso con',
        alert: {
          positive: "L'email di invito è stata inviata",
          negative:
            'Qualcosa è andato storto. Riprova più tardi o contatta i tuoi referenti',
          guest_info:
            'La persona invitata non vedrà i pacchetti retributivi dei candidati. Se deve avere accesso a queste informazioni, richiedi a {{ mainClient }} o all’head hunter di abilitare i permessi.',
        },
        table: {
          header: {
            name: 'Nome',
            email: 'Mail',
            compensationVisibility: 'Visibilità retribuzioni',
          },
          guest: '(Guest)',
          mainClient: '(Main client)',
        },
      },
    },
    validation: {
      scout_approved: 'Validato da Scout',
      scout_required: 'Validare con Scout',
      required: 'Questo campo è richiesto',
      email: 'Questo indirizzo email non è valido',
    },
    language_switcher: {
      it: 'IT',
      en: 'EN',
      de: 'DE',
      fr: 'FR',
      es: 'ES',
    },
    showcase,
    candidateDetails: CANDIDATE_DETAILS_IT,
    common: COMMON_IT,
    interviewing: INTERVIEWING_IT,
    searching: SEARCHING_IT,
    closing: CLOSING_IT,
    successFee: SUCCESS_FEE_IT,
    globalCompensation: GLOBAL_COMPENSATION_IT,
    homepage: HOMEPAGE_IT,
    login: LOGIN_IT,
    profiling: PROFILING_IT,
    errors: ERRORS_IT,
  },
};

export default it;
